// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ContentZone from "@store/Library/Components/ContentZone";
import * as React from "react";

type Props = WidgetProps & HasProduct;

const ProductDetailsWarranty: React.FC<Props> = ({ product }) => {
    const content = product.properties.warranty;
    if (!content) {
        return null;
    }
    return <ContentZone content={content} contentCellWidth={12} />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsWarranty),
    definition: {
        displayName: "Warranty",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
